export const DATE_TIME_FORMAT = "MM-DD-YYYY h:mm A";
export const DATE_FORMAT = "MM-DD-YYYY";
export const STANDARD_DATE_FORMAT_NO_TIME = "YYYY-MM-DD";
export const ALLERGY_RXCUI = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/allergy-rxcui`;

export const ALLERGY_CODETYPE = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/allergy-codetype`;
